import React, { Component } from 'react';
import './FilterSidebar.css';

import MediaQuery from 'react-responsive';
import Checkbox from './Checkbox.js';
import CharacterSelect from './CharacterSelect.js';
import CharacterImg from './CharacterImg.js';
import Popup from './Popup.js';
import ListTable from './ListTable.js';

class FilterSidebar extends Component {
    constructor(props){
        super(props);
        this.state = {characterSelect:false, filters:{characters:[]}, mini:false};
        this.toggleCharacterSelect = this.toggleCharacterSelect.bind(this);
        this.setCharacter = this.setCharacter.bind(this);
        this.changeQuantity = this.changeQuantity.bind(this);
        this.removeCharacter = this.removeCharacter.bind(this);
        this.closeCSS = this.closeCSS.bind(this);
    }

    updated(key, value) {
        let filters = this.state.filters;

        if (key === "characters") {
            if (!(filters["characters"].indexOf(value) !== -1)) {
                filters["characters"].push(value);
            } else {
                filters["characters"].splice(filters["characters"].indexOf(value), 1);
            }
        } else {
            filters[key] = value;
        }

        this.setState({filters:filters});
    }

    sendSearch(mini) {
        if (typeof this.props.updated === "function") {
            this.props.updated(this.state.filters);
            this.setState({mini:mini});
        }
    }

    toggleCharacterSelect(character="") {
        this.setState({characterSelect:!this.state.characterSelect});
    }

    setCharacter(character="") {
        this.setState({characterSelect:!this.state.characterSelect});
        if (character !== "") {
            this.updated("characters", character);
        }
    }

    closeCSS() {
        this.setState({characterSelect:false});
    }

    removeCharacter(character) {
        this.updated("characters", character);
    }

    changeQuantity(type, e) {
        this.updated(type, e.target.value);
    }

    searchAgain() {
        this.setState({mini:false});
    }


    render() {
        let characterList = [];

        if (this.state.mini) {
            return (
                <div className={"filter-sidebar mini"} onClick={() => this.searchAgain()}>
                  <h2>c<br/>h<br/>a<br/>n<br/>g<br/>e</h2>
                  <h2>f<br/>i<br/>l<br/>t<br/>e<br/>r<br/>s</h2>
                </div>
            );
        }

        for (let charIndex in this.state.filters.characters) {
            let char = this.state.filters.characters[charIndex];

            characterList.push(<CharacterImg remove={this.removeCharacter} character={char} />);
        }

        // if any game data filter is active
        let forceGameData = true ? "" : "";

        let checkboxFilters = [
            ["Game Data",  <Checkbox forcedState={forceGameData} updated={(state) => {this.updated("hasData", state);}} />, "Percent Data", <Checkbox updated={(state) => {this.updated("hasPercentData", state);}} />],
            ["Stock Data", <Checkbox updated={(state) => {this.updated("hasStockData", state);}} />, "Character Data", <Checkbox updated={(state) => {this.updated("hasCharData", state);}} />],
            ["Lag Data", <Checkbox updated={(state) => {this.updated("hasLagData", state);}} />]
        ];


        let filterList = [
            ["Min Lag", <input type="number" id="min-lag" placeholder="No Minimum" step="0.1" min="0" onChange={(e) => this.changeQuantity("minLag", e)}/>],
            ["Max Lag", <input type="number" id="max-lag" placeholder="No Maximum" step="0.1" min="0" onChange={(e) => this.changeQuantity("maxLag", e)}/>],
            ["", <br />],
            ["Char Count", <input type="number" placeholder="Min Char Count" name="quantity" min="0" onChange={(e) => this.changeQuantity("characterCount", e)} ></input>],
            ["Game Count", <input type="number" placeholder="Min Game Count" name="quantity" min="0" onChange={(e) => this.changeQuantity("gameCount", e)} ></input>],

            ["Game Type", (
                <select id="game-type" onChange={(e) => this.changeQuantity("gameType", e)}>
                  <option value="any">Any Mode</option>
                  <option value="1v1">For Glory Singles</option>
                  <option value="2v2">For Glory Team Smash</option>
                  <option value="both">Both Modes</option>
                </select>
            )
            ],
            ["", <br />],
            ["Min Win %", <input type="number" id="min-win-rate" placeholder="No Minimum" step="1" min="0" onChange={(e) => this.changeQuantity("minWinRate", e)}/>],
            ["Max Win %", <input type="number" id="max-win-rate" placeholder="No Maximum" step="1" max="100" onChange={(e) => this.changeQuantity("maxWinRate", e)}/>],

            ["Mii Name", <input type="text" onChange={(e) => this.changeQuantity("name", e)}></input>]
        ];


        return (
            <div className="filter-sidebar">
              <h2>Filters</h2>
              <ListTable classes={["td-right", null, "td-right"]} list={checkboxFilters}/>

              <ListTable classes={["td-right"]} list={filterList} />

              <h4>Characters</h4>
              <span>Plays <select onChange={(e) => this.changeQuantity("charType", e)}><option value="all">All</option><option value="any">Any</option><option value="none">None</option></select> of these <button onClick={this.toggleCharacterSelect}>Characters</button></span>
              <div className="character-list">
                {characterList}
              </div>
              {this.props.results}
              {false && <div>
                    <br/><br/><br/><br/>
                        *Results are averaged from remaining players. If you filter to all players who play Mario, it will show the win rate of people who have played Mario (including their performance with other characters).
                  </div>
              }

              { this.state.characterSelect && <Popup close={this.closeCSS}>
                    <CharacterSelect selected={this.setCharacter}/>
              </Popup> }
              <MediaQuery maxWidth={850}>
                <button onClick={() => this.sendSearch(true)} className="search-button">Search</button>
              </MediaQuery>
              <MediaQuery minWidth={850}>
                <button onClick={() => this.sendSearch(false)} className="search-button">Search</button>
              </MediaQuery>              
            </div>
        );

    }
}

export default FilterSidebar;
